import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Efectivo } from '../../../models/finanzas/efectivo/efectivo.model';
import { EfectivoService } from '../../../services/finanzas/efectivo/efectivo.service';
import { NotificationService } from '../../../modules_v2/shared/services/notification.service';

export interface EfectivoDialogFormData {
  efectivo?: Efectivo;
  isEditMode: boolean;
}

@Component({
    selector: 'convfact-efectivodialogform',
    templateUrl: './efectivo-dialog-form.component.html',
    styleUrls: ['./efectivo-dialog.component.css'],
    standalone: false
})
export class EfectivoDialogFormComponent implements OnInit {

  public efectivo: Efectivo;
  public isEditMode = false;

  showApiKey = false;
  saving = false;
  submitted = false;
  saveError = '';

  static open(dialog: MatDialog, data: EfectivoDialogFormData): Observable<boolean> {
    return dialog.open<EfectivoDialogFormComponent, EfectivoDialogFormData, boolean>(EfectivoDialogFormComponent, {
      width: '560px',
      maxWidth: '96vw',
      maxHeight: '90vh',
      data,
    }).afterClosed().pipe(map(result => result === true));
  }

  constructor(
    public dialogRef: MatDialogRef<EfectivoDialogFormComponent, boolean>,
    public efectivoService: EfectivoService,
    @Inject(MAT_DIALOG_DATA) public data: EfectivoDialogFormData,
    private notify: NotificationService,
  ) { }

  get missingNombre(): boolean {
    return !(this.efectivo.nombre || '').toString().trim();
  }

  get missingUbicacion(): boolean {
    return !(this.efectivo.ubicacion || '').toString().trim();
  }

  public ngOnInit(): void {
    if (this.data && this.data.isEditMode && this.data.efectivo) {
      this.isEditMode = true;
      const source = this.data.efectivo;
      this.efectivo = {
        uid: source.uid,
        accountingModelsNumber: source.accountingModelsNumber,
        nombre: source.nombre,
        ubicacion: source.ubicacion,
        saldoContable: source.saldoContable,
        manualMovement: source.manualMovement,
        fondoDeCaja: source.fondoDeCaja,
      };
      return;
    }

    this.efectivo = {
      accountingModelsNumber: '',
      nombre: '',
      ubicacion: '',
      uid: '',
      saldoContable: 0,
      manualMovement: null,
      fondoDeCaja: 0,
    };
  }

  public save(): void {
    if (this.saving) return;
    this.submitted = true;
    this.saveError = '';
    if (this.missingNombre || this.missingUbicacion) return;

    this.saving = true;
    this.dialogRef.disableClose = true;

    const request = this.isEditMode
      ? this.efectivoService.edit(this.efectivo)
      : this.efectivoService.add(this.efectivo);

    request
      .then(() => {
        this.notify.ok(this.isEditMode ? 'Caja actualizada correctamente' : 'Caja creada correctamente');
        this.dialogRef.disableClose = false;
        this.dialogRef.close(true);
      })
      .catch(error => {
        this.saving = false;
        this.dialogRef.disableClose = false;
        this.saveError = (error && error.error && error.error.message)
          || (this.isEditMode ? 'Ha ocurrido un error inesperado al actualizar la caja' : 'Ha ocurrido un error inesperado al crear la caja');
      });
  }

  public closeDialog(): void {
    if (this.saving) return;
    this.dialogRef.close(false);
  }
}
